/**
 * Os termos de uso e a política de privacidade (docs/spec/termos.md): a versão que o cadastro aceita,
 * a data da versão, a idade mínima e o prazo dos registros de acesso.
 */

/**
 * A versão atual dos termos de uso e da política de privacidade, aceitos juntos. Subir este número
 * pede o aceite de novo a quem já tem conta, ao entrar. A 1 era o texto curto do começo do projeto.
 */
export const CURRENT_TOS_VERSION = 2;

/** A data da versão atual (aaaa-mm-dd), no alto das duas páginas. */
export const TOS_UPDATED_AT = '2026-11-03';

/** A idade mínima para ter conta (termos, seção 3). */
export const MIN_AGE = 18;

/**
 * Por quanto tempo o servidor guarda os registros de acesso (IP, data e hora): os 6 meses do Marco
 * Civil da Internet (Lei 12.965/2014, art. 15), contados em 183 dias para cobrir qualquer semestre.
 */
export const ACCESS_LOG_RETENTION_MS = 183 * 24 * 60 * 60 * 1000;
